module.exports = __webpack_public_path__ + "static/media/AMEX.59c08423.svg";